import * as React from 'react';
import { ArticleParagraph1, Responsive, UIHeading1, UIHeading2, UIHeading5 } from '@cian/ui-kit';
import * as styles from './styles.css';
import { ProjectsLink } from '../ProjectsLink';

interface ITitleProps {
  counter: string;
  withProjectsLink?: boolean;
}

export const Title = ({ counter, withProjectsLink }: ITitleProps) => (
  <>
    <div className={styles['title']}>
      <Responsive desktop>
        <UIHeading1>Строительные компании</UIHeading1>
      </Responsive>
      <Responsive tablet phone>
        <UIHeading2>Строительные компании</UIHeading2>
      </Responsive>
    </div>
    <div className={styles['subtitle']}>
      <ArticleParagraph1>
        Надёжные компании, одобренные нашими экспертами: проверили историю каждой и&nbsp;изучили отзывы о&nbsp;работе
      </ArticleParagraph1>
    </div>
    <div className={styles['counter']}>
      <UIHeading5>{counter}</UIHeading5>
      {withProjectsLink && (
        <div className={styles['projects-link']}>
          <ProjectsLink />
        </div>
      )}
    </div>
  </>
);
